import type { ReferralOwnerRow, ReferralOwnerType, ReferralsListResponse } from '@manaro/contracts'
import { buildCsv, csvDate, downloadCsv, type CsvColumn } from '@/shared/lib/csv.ts'

const MAX_EXPORT_PAGES = 200

const OWNER_COLUMNS: CsvColumn<ReferralOwnerRow>[] = [
  ['Код', (row) => row.code],
  ['Владелец', (row) => row.ownerName ?? ''],
  ['Email', (row) => row.ownerEmail ?? ''],
  ['Приглашено', (row) => row.invited],
]

const INVITEE_KIND_COLUMNS: CsvColumn<ReferralOwnerRow>[] = [
  ['Пользователей', (row) => row.users],
  ['Бизнесов', (row) => row.businesses],
]

const SUMMARY_COLUMNS: CsvColumn<ReferralOwnerRow>[] = [
  ['Активных', (row) => row.active],
  ['Подозрительных', (row) => row.suspicious],
  ['Код создан', (row) => csvDate(row.createdAt)],
]

export function referralsCsv(rows: ReferralOwnerRow[], ownerType: ReferralOwnerType): string {
  const columns =
    ownerType === 'business'
      ? [...OWNER_COLUMNS, ...INVITEE_KIND_COLUMNS, ...SUMMARY_COLUMNS]
      : [...OWNER_COLUMNS, ...SUMMARY_COLUMNS]

  return buildCsv(columns, rows)
}

export async function collectAllReferrals(
  fetchPage: (page: number) => Promise<ReferralsListResponse>,
): Promise<ReferralOwnerRow[]> {
  let collected: ReferralOwnerRow[] = []

  for (let page = 1; page <= MAX_EXPORT_PAGES; page += 1) {
    const { rows, total } = await fetchPage(page)
    collected = [...collected, ...rows]
    if (rows.length === 0 || collected.length >= total) break
  }

  return collected
}

export function downloadReferralsCsv(rows: ReferralOwnerRow[], ownerType: ReferralOwnerType): void {
  const scope = ownerType === 'business' ? 'businesses' : 'users'
  downloadCsv(`manaro-referrals-${scope}-${new Date().toISOString().slice(0, 10)}.csv`, referralsCsv(rows, ownerType))
}
